import { relations } from "drizzle-orm";
import {
  index,
  integer,
  pgEnum,
  pgTable,
  text,
  timestamp,
  uuid,
  vector,
} from "drizzle-orm/pg-core";
import { business } from "./businesses";
import { articleStatusEnum } from "./enums";

export const article = pgTable("article", {
  id: uuid("id").primaryKey().defaultRandom(),
  business_id: integer("business_id")
    .notNull()
    .references(() => business.id, { onDelete: "cascade" }),

  title: text("title"),
  content: text("content"),
  keywords: text("keywords").array(),

  meta_description: text("meta_description"),

  summary: text("summary"),
  tone: text("tone"),
  type: text("type"),

  coverPhotoUrl: text("cover_photo_url"),

  status: articleStatusEnum("status")
    .notNull()
    .default("scheduled-for-writing"),
  writtenAt: timestamp("written_at"),
  scheduledDate: timestamp("scheduled_date", { withTimezone: true }),
  createdAt: timestamp("created_at").notNull().defaultNow(),
});

export const articleRelations = relations(article, ({ one }) => ({
  business: one(business, {
    fields: [article.business_id],
    references: [business.id],
  }),
}));

export const ArticleEmbeddingType = pgEnum("ArticleEmbeddingType", [
  "content_chunk",
  "title",
  "other",
]);

export const articleEmbedding = pgTable(
  "article_embedding",
  {
    id: uuid("id").primaryKey().defaultRandom(),
    article_id: uuid("article_id")
      .notNull()
      .references(() => article.id, { onDelete: "cascade" }),

    content: text("content").notNull(),

    type: ArticleEmbeddingType().default("other"),

    embedding: vector("embedding", { dimensions: 1536 }).notNull(),

    createdAt: timestamp("created_at").notNull().defaultNow(),
  },
  (table) => [
    index("embedding_index").using(
      "hnsw",
      table.embedding.op("vector_cosine_ops")
    ),
  ]
);

export const articleEmbeddingRelations = relations(
  articleEmbedding,
  ({ one }) => ({
    article: one(article, {
      fields: [articleEmbedding.article_id],
      references: [article.id],
    }),
  })
);
